import {injectable} from '@123/druid/dist/Framework/Decorators/Inject';
import CookieStorage from './CookieStorage';

@injectable()
export default class CookieService {
    private static readonly ALLOWED_COOKIES = ['forcedTemplateMessage', 'EmergencyNotification', 'locale_redirect_hide'];
    private readonly cookieStorage: CookieStorage;

    constructor(options?: CookieInit) {
        this.cookieStorage = new CookieStorage(options);
    }

    public async setCookie(options: CookieInit, days?: number, overwrite: boolean = false): Promise<void> {
        if (CookieService.ALLOWED_COOKIES.includes(options.name) === false && overwrite === false) {
            throw new Error(`The cookie with name: ${options.name}, is not allowed`);
        }

        if (typeof days === 'number' && typeof options.expires === 'undefined') {
            options.expires = new Date().getTime() + days * CookieStorage.TTL;
        }

        await this.cookieStorage.setJson('', options, false);
    }

    public async getCookie(name: string): Promise<string | null> {
        return this.cookieStorage.getStringOrNull(name);
    }

    public async getCookies(): Promise<string[]> {
        return this.cookieStorage.keys();
    }

    public async removeCookie(name: string): Promise<void> {
        await this.cookieStorage.remove(name);
    }

    public async removeCookies(): Promise<void> {
        await this.cookieStorage.clear();
    }
}
